import { Radio, RadioGroup, Text, Flex } from '@ritualco/jutsu'
import { Form, useFormikContext } from 'formik'
import { FormikMultiEmailInput } from 'components/Formik'
import { useContent } from 'lib/content/react'
import { MemberCreateModalProps, MemberCreateModalValues } from './types'

type MemberCreateModalFormProps = Pick<MemberCreateModalProps, 'roles'>

export const MemberCreateModalForm = ({
  roles,
}: MemberCreateModalFormProps) => {
  const { values, setFieldValue } = useFormikContext<MemberCreateModalValues>()
  const { formatMessage } = useContent()

  return (
    <Form id="memberCreate">
      <FormikMultiEmailInput
        name="emails"
        label={formatMessage({ id: 'pmportal.settings.team.emailsLabel' })}
        placeholder={formatMessage({
          id: 'pmportal.settings.team.emailsPlaceholder',
        })}
        isRequired
      />
      <Text color="grayscale.secondary" fontSize="xsmall" mb={1}>
        {formatMessage({ id: 'pmportal.settings.team.roleDescription' })}
      </Text>
      <RadioGroup
        name="role"
        value={values.role}
        onChange={val => setFieldValue('role', val)}
      >
        {roles.map(({ label, value, description }) => (
          <Flex
            key={value}
            py={4}
            borderTop="1px solid"
            borderTopColor="grayscale.quinary"
            justify="space-between"
            align="center"
            flexWrap="wrap"
          >
            <Radio value={value} size="lg">
              <Text fontSize="small" fontWeight="medium" ml={4}>
                {label}
              </Text>
            </Radio>
            <Text fontSize="small" w="415px" ml={12}>
              {description}
            </Text>
          </Flex>
        ))}
      </RadioGroup>
    </Form>
  )
}
